export default function PHP_intdiv() {
  return (
    <div>
      <h1>PHP_intdiv</h1>
    </div>
  );
}
